<template>
  <div class="teamWorkerInput flex-b" @click="open">
    <div class="scroll flex-1 flex-s">
      <template v-if="props.value.length">
        <div class="inputItem flex" v-for="(i, index) in props.value" :key="index">
          <userAvatar :src="i.avatar" :size="22" />
          <div class="mr-4 ml-4" style="white-space: nowrap">{{ i.nickName }}</div>
          <CloseOutlined class="fs-12" @click.stop="close(i)" />
        </div>
      </template>
      <div class="placeholder" v-else>{{ props.placeholder }}</div>
    </div>
    <PlusOutlined class="ml-11" />
  </div>
</template>
<script setup>
import { Form as AForm } from 'ant-design-vue'
import { CloseOutlined, PlusOutlined } from '@ant-design/icons-vue'
import userAvatar from '@/components/userAvatar.vue'
import { aigcStore } from '@/store/aigcStore'
import eventsBus from '@/utils/eventsBus'

const props = defineProps({
  value: {
    type: Array,
    default: () => []
  },
  placeholder: {
    type: String,
    default: '请选择'
  }
})
const emits = defineEmits(['update:value'])
const store = aigcStore()
const formItemContext = AForm.useInjectFormItemContext()

const close = (i) => {
  emits(
    'update:value',
    props.value.filter((item) => item.id != i.id)
  )
  formItemContext.onFieldChange()
}
const open = () => {
  store.openTeamWorkerModal({
    modalType: 'data',
    data: props.value
  })
}
eventsBus.on('teamUser', (res) => {
  const arr = [...res.selectPersonList]
  console.log(arr)

  emits('update:value', arr)
  formItemContext.onFieldChange()
  store.closeTeamWorkerModal()
})
</script>

<style lang="less" scoped>
.teamWorkerInput {
  box-sizing: border-box;
  margin: 0;
  padding: 0 11px;
  color: rgba(0, 0, 0, 0.88);
  font-size: 14px;
  line-height: 1.5714285714285714;
  list-style: none;
  width: 100%;
  min-width: 0;
  background-color: #ffffff;
  background-image: none;
  border-width: 1px;
  border-style: solid;
  border-color: #d9d9d9;
  border-radius: 6px;
  transition: all 0.2s;
  height: 32px;
  cursor: pointer;
}
.teamWorkerInput:hover {
  border-color: @theme-color;
  border-inline-end-width: 1px;
}
.inputItem {
  background: #f1f1f1;
  border-radius: 99px;
  padding: 2px 4px;
  user-select: none;
}
.scroll {
  overflow-x: auto;
  scrollbar-width: none;
}
.placeholder {
  color: #ccc;
}
:deep(img) {
  width: 22px;
  height: 22px;
}
</style>
